import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function AboutPage() {
  const [contactFormMsg, setContactFormMsg] = useState('');
  const [contactFormError, setContactFormError] = useState('');

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Breadcrumb />

        {/* Hero */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
            <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
              <i className="ri-book-read-line text-primary-600 text-2xl"></i>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading">
              关于歪歪漫画
            </h1>
            <p className="mt-3 text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              最新高清免费韩国漫画大全，热门无删减韩漫在线阅读平台
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="grid lg:grid-cols-2 gap-10 items-center">
              <div>
                <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">品牌故事</span>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mt-2">
                  让每一个韩漫爱好者都能找到心仪之作
                </h2>
                <div className="space-y-4 mt-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    歪歪漫画网成立于2020年，是国内领先的韩国漫画在线阅读平台。我们致力于为广大漫画爱好者提供最新、最全、最高清的韩国漫画资源，打造一个纯粹、便捷的在线阅读社区。
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    平台汇集了超过500部精选韩漫作品，涵盖恋爱、动作、奇幻、悬疑、搞笑、都市、校园、古风等八大分类，满足不同读者的阅读偏好。所有漫画均为高清画质、无删减版本，让您体验原汁原味的韩国漫画魅力。
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    我们与多家韩国漫画版权方建立了合作关系，确保内容的合法性和更新速度。热门连载漫画平均每周更新1-2话，让读者无需漫长等待。
                  </p>
                </div>
              </div>
              <div className="relative">
                <div className="aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20modern%20cozy%20reading%20space%20with%20warm%20ambient%20lighting%2C%20bookshelves%20filled%20with%20colorful%20books%20and%20comics%2C%20comfortable%20seating%20area%2C%20digital%20tablet%20displaying%20webtoon%2C%20clean%20minimal%20design%2C%20warm%20coral%20and%20cream%20accents%2C%20inviting%20atmosphere&width=800&height=600&seq=about-brand-2026&orientation=landscape"
                    alt="歪歪漫画品牌形象"
                    title="歪歪漫画网 - 韩国漫画在线阅读平台"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full py-12 bg-primary-500">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              {[
                { value: '500+', label: '漫画资源' },
                { value: '120万+', label: '活跃读者' },
                { value: '9.4', label: '平均评分' },
                { value: '99.9%', label: '服务可用率' },
              ].map((stat, idx) => (
                <div key={idx}>
                  <div className="text-3xl md:text-4xl font-bold text-background-50 font-heading">{stat.value}</div>
                  <div className="text-sm text-background-50/70 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">用户口碑</span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mt-2">
                读者真实评价
              </h2>
            </div>
            <div className="grid md:grid-cols-3 gap-5">
              {[
                {
                  name: '小雨',
                  rating: 5,
                  text: '歪歪漫画网是我用过最好的韩漫阅读平台！更新速度超快，画质也很高清。最喜欢《我们的青涩时光》，每周都在等更新！',
                },
                {
                  name: '追风少年',
                  rating: 5,
                  text: '分类很全，想看的韩漫基本都能找到。界面很干净没有乱七八糟的广告，阅读体验特别好。强烈推荐！',
                },
                {
                  name: '星星点灯',
                  rating: 4,
                  text: '收藏了很多韩漫，手机上看也很方便。希望能早点出离线下载功能，这样在地铁上也能看了。整体来说非常棒！',
                },
              ].map((review, idx) => (
                <div key={idx} className="bg-background-100 rounded-xl p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }, (_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
                  <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200/70">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-xs font-medium text-primary-700">
                      {review.name[0]}
                    </div>
                    <span className="text-sm font-medium text-foreground-700">{review.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-8">
                <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">联系我们</span>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mt-2">
                  有任何问题？欢迎联系
                </h2>
                <p className="text-sm text-foreground-500 mt-2">
                  无论是版权合作、问题反馈还是意见建议，我们都期待听到您的声音
                </p>
              </div>

              {/* Contact Info Cards */}
              <div className="grid sm:grid-cols-3 gap-4 mb-8">
                <div className="bg-background-50 rounded-xl p-5 text-center">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-mail-line text-primary-600"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">电子邮箱</p>
                  <p className="text-sm font-medium text-foreground-800">contact@waiwaimanhua.com</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5 text-center">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-customer-service-line text-primary-600"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">在线客服</p>
                  <p className="text-sm font-medium text-foreground-800">工作日 9:00-18:00</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5 text-center">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-map-pin-line text-primary-600"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">公司地址</p>
                  <p className="text-sm font-medium text-foreground-800">中国·北京</p>
                </div>
              </div>

              {/* Contact Form */}
              <form
                data-readdy-form=""
                action="https://readdy.ai/api/form/d9pev0di2vhsdh2d3300"
                method="POST"
                className="bg-background-50 rounded-xl p-6 space-y-4"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const honeypot = (form.querySelector('[name="company_alt"]') as HTMLInputElement)?.value.trim();
                  if (honeypot) {
                    setContactFormMsg('感谢您的留言！我们会尽快回复。');
                    setContactFormError('');
                    return;
                  }
                  const formData = new FormData(form);
                  fetch('https://readdy.ai/api/form/d9pev0di2vhsdh2d3300', { method: 'POST', body: formData })
                    .then(async (res) => {
                      const t = await res.text();
                      let parsed;
                      try { parsed = JSON.parse(t); } catch { parsed = null; }
                      const serverMsg = parsed?.meta?.message || parsed?.message || '';
                      if (res.ok && parsed?.code === 'OK') {
                        setContactFormMsg('感谢您的留言！我们会尽快回复。');
                        setContactFormError('');
                        form.reset();
                      } else {
                        setContactFormError(serverMsg || '提交失败，请稍后重试');
                        setContactFormMsg('');
                      }
                    })
                    .catch(() => {
                      setContactFormError('网络错误，请稍后重试');
                      setContactFormMsg('');
                    });
                }}
              >
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="请输入您的姓名"
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-800 placeholder-foreground-400 outline-none focus:border-primary-400 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="请输入您的邮箱地址"
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-800 placeholder-foreground-400 outline-none focus:border-primary-400 transition-colors"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                  <input
                    type="text"
                    name="subject"
                    required
                    placeholder="请输入留言主题"
                    className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-800 placeholder-foreground-400 outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                  <textarea
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    placeholder="请输入您的留言内容（最多500字）"
                    className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-800 placeholder-foreground-400 outline-none focus:border-primary-400 transition-colors resize-none"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
                </div>
                <div className="sp-field--website_alt">
                  <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
                <button
                  type="submit"
                  className="w-full py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  发送留言
                </button>
                {contactFormMsg && (
                  <p className="text-sm text-green-600 text-center">{contactFormMsg}</p>
                )}
                {contactFormError && (
                  <p className="text-sm text-red-500 text-center">{contactFormError}</p>
                )}
              </form>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}